import { Col, Row } from '@/components';
import type { FC, PropsWithChildren } from 'react';

export const Centralizer: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Row justify="center">
      <Col>{children}</Col>
    </Row>
  );
};
